import { useEffect, useState } from 'react';
import { Session, AuthChangeEvent } from '@supabase/supabase-js';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

export function useAuth() {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      try {
        setLoading(true);
        const { data: { session: currentSession }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('Session check error:', error);
          
          // Handle invalid refresh token by signing out
          if (error.message && error.message.includes('Refresh Token Not Found')) {
            console.log('Invalid refresh token detected, signing out...');
            await supabase.auth.signOut();
            setSession(null);
            return;
          }
          
          throw error;
        }
        
        setSession(currentSession);
      } catch (err) {
        console.error('Auth error:', err);
        // Only clear session if it's an auth error, not a network error
        if (err.message !== 'Failed to fetch') {
          setSession(null);
        }
      } finally {
        setLoading(false);
      }
    };

    checkSession();

    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange(async (event: AuthChangeEvent, currentSession) => {
      if (event === 'SIGNED_OUT' || event === 'USER_DELETED') {
        setSession(null);
        if (event === 'USER_DELETED') {
          toast.error('Je account is verwijderd');
        }
      } else if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        setSession(currentSession);
        if (event === 'TOKEN_REFRESHED') {
          // Token refresh successful, no need to notify user
        }
      } else if (event === 'INITIAL_SESSION') {
        setSession(currentSession);
      }
      setLoading(false);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  return { session, loading };
}